import axios from "axios";
import { PaginatedResponse } from "models/common/responseObjects";
import { GenericCategoryView } from "models/dbModels/genericCategories/GenericCategory";
import { GenericCategorySearchFilterQuery } from "models/filters/genericCategories/GenericCategorySearchFilterQuery";

export class GenericCategoriesApi {
    static Search = async (query: GenericCategorySearchFilterQuery) => axios.post<PaginatedResponse<GenericCategoryView[]>>(`api/v1/GenericCategories/Search`, query);
}